import script from "./DomainModel.vue?vue&type=script&setup=true&lang=js"
export * from "./DomainModel.vue?vue&type=script&setup=true&lang=js"

import "./DomainModel.vue?vue&type=style&index=0&id=09a89795&scoped=true&lang=css"
import "./DomainModel.vue?vue&type=style&index=1&id=09a89795&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09a89795"]])

export default __exports__